export function biomarkerPanelSummaryValue(value) {
    return value || '\u2014';
}
export function getDiseaseType(configs, cancerTypeId) {
    if (!configs || !cancerTypeId) {
        return null;
    }
    return configs.find(function (x) { return x.value === cancerTypeId; });
}
